export const supportFaqKeys = {
  all: ["support-faq"] as const,
  lists: () => [...supportFaqKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) => [...supportFaqKeys.lists(), params] as const,
  details: () => [...supportFaqKeys.all, "detail"] as const,
  detail: (id: string) => [...supportFaqKeys.details(), id] as const,
  systemLists: () => [...supportFaqKeys.all, "system-list"] as const,
  systemList: (params?: Record<string, unknown>) =>
    [...supportFaqKeys.systemLists(), params] as const,
};
